import { Component, OnDestroy, OnInit} from '@angular/core';
import { Competency } from '../common/models/competency';
import { CompetencyService } from '../common/services/competency.service';
import { UserService } from '../common/services/user.service';
import {Plan} from "../common/models/plan";
import {Subject} from "rxjs";
import {SharedService} from "../common/services/shared.service";
import {MatDialog} from "@angular/material/dialog";
import {SnackbarComponent} from "../snackbar/snackbar.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {PlanEditService} from "../common/services/plan-edit.service";
import {Router} from "@angular/router";
import {Activity} from "../common/models/activity";
import {
  ConfirmationDialogComponent,
  ConfirmDialog
} from "../dialogs/dialog-unsaved-changes/confirmation-dialog.component";

@Component({
    selector: 'app-view-saved-competencies',
    templateUrl: './view-saved-competencies.component.html',
    styleUrls: ['./view-saved-competencies.component.css'],
    standalone: false
})

export class ViewSavedCompetenciesComponent implements OnInit, OnDestroy  {

  savedCompetencies: Competency[];
  plan: Plan;
  userId: string;

   onDestroy$: Subject<boolean> = new Subject();
  constructor(private competencyService: CompetencyService, private userService: UserService, private sharedService: SharedService, private dialog: MatDialog, private _snackBar: MatSnackBar, private planEditService: PlanEditService, private router: Router){}

  ngOnInit(): void {
    this.userService.user().subscribe({ next: (user) => {
      this.sharedService.plan$.subscribe( {next: (value) =>{
        this.plan = value;
        }});
      this.userId = user.Id;
      this.competencyService.getCompetenciesByUserId(user.Id).subscribe({ next: (competencies) => {
        this.savedCompetencies = competencies;
      }});
    }});
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.unsubscribe();
  }
  openSnackbarError(message: string) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: message, panelClass: 'snackbar-error'
    });
  }
  redirectToEditPlan(): void{
    this.planEditService.setIsEditing(true, 3, this.plan.PlanYear);
    this.router.navigateByUrl('app/selfassessment');
  }


  deleteItem( competency : Competency) : void{
    const confirm = new ConfirmDialog();
    confirm.title = "Remove saved competency?";
    confirm.message = "Are you sure you want to remove this saved competency?";
    confirm.message2 = "Your self-assessment, learning activities, and notes saved with this competency will be removed.";
    confirm.okButtonTitle = "Continue";
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '525px',
      height: '450px',
      panelClass: 'pending-changes',
      data: confirm,
      disableClose: false,
      ariaLabelledBy: 'confirm-desc'
    });


    //dialogRef.componentInstance.data.message = "Are you sure you want to remove this saved competency?";
    dialogRef.afterClosed().subscribe((result) =>{
      if(result === 'ok')
      {
        this.competencyService.deleteCompetency(competency).subscribe({
          next: () => {
            this.competencyService.getCompetenciesByUserId(this.userId).subscribe({ next: (competencies) => {
                this.savedCompetencies = competencies;
              }});
          },
          error: () => this.openSnackbarError("Unable to delete competency")
        });

      }
    });
  }

  public checkActivity(item: Activity): boolean {
    return item.ActivityTemplate !== null  && item.ActivityTemplate.Name !== '' && item.ActivityTemplate.Name !== null
      && (item.ActivityTemplate.Name !== 'Other' ||( item.Description !== null && item.ActivityTemplate.Name === 'Other'));
  }

  public getActivityName(item: Activity): string {

    if(item.ActivityTemplate !== null  && item.ActivityTemplate.Name !== '' && item.ActivityTemplate.Name !== null)
    {

      return item.ActivityTemplate.Name !== 'Other' ? item.ActivityTemplate.Name : item.Description;
    }
      return "";

  }
}
